import { ComunicazioneDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { FlexRow } from '@framework/ui';
import {
  Divider,
  Empty,
  Flex,
  Pagination,
  PaginationProps,
  Typography,
} from 'antd';
import * as React from 'react';
import { CommunicationItem } from './CommunicationItem';
import { ICommonCommunicationProps } from './logic/ICommonCommunicationProps';

interface CommunicationListProps
  extends Pick<
    ICommonCommunicationProps,
    'deleteDraft' | 'getDownloadAttachmentQueryOptions'
  > {
  communications?: ComunicazioneDTO[];
  pagination?: PaginationProps;
  extra?: React.ReactNode;
  isEditable?: boolean;
  onOpen: (communication: ComunicazioneDTO) => void;
  /** Mostra il pulsante "Rispondi" sulle comunicazioni con `flAbilitaRisposta` */
  onReply?: (communication: ComunicazioneDTO) => void;
}

/**
 * Elenco delle comunicazioni con paginazione
 */
export function CommunicationList(props: CommunicationListProps) {
  const {
    communications,
    pagination,
    extra,
    isEditable = true,
    onOpen,
    onReply,
    deleteDraft,
    getDownloadAttachmentQueryOptions,
  } = props;

  const { t } = useTranslation();

  if (!communications) return null;

  // se non si sono comunicazioni, mostriamo comunque l'extra
  // che include il pulsante per inviare una comunicazione
  if (communications.length === 0) {
    return (
      <div>
        <Empty
          description={
            <Typography.Text>
              {t(
                'communication-list.no-comms-to-show',
                'Non ci sono comunicazioni da mostrare',
              )}
            </Typography.Text>
          }
        />
        {extra && (
          <>
            <Divider />
            {extra}
          </>
        )}
      </div>
    );
  }

  return (
    <Flex vertical gap={16}>
      {communications.map(communication => (
        <CommunicationItem
          key={communication.id}
          communication={communication}
          onOpen={onOpen}
          onReply={onReply}
          isEditable={isEditable}
          deleteDraft={deleteDraft}
          getDownloadAttachmentQueryOptions={getDownloadAttachmentQueryOptions}
        />
      ))}
      <FlexRow
        right={
          <Pagination size="small" total={50} showSizeChanger {...pagination} />
        }
      >
        {extra}
      </FlexRow>
    </Flex>
  );
}
